const headerClickTracking = {
  action: 'click',
  category: 'header_navigation',
  type: 'header_item',
  label: '',
};

export { headerClickTracking };
